import {Chart, LinearScale, BarElement, BarController, CategoryScale, Title, Tooltip} from 'chart.js'

Chart.register(LinearScale, BarElement, BarController, CategoryScale, Title, Tooltip)

export class AnnualDividendsGraph

  constructor: ->
    @buildGraph() if @canvas()

  canvas: ->
    @graphCanvas or= document.querySelector('canvas#annual-dividends-graph')

  buildGraph: ->
    chart = new Chart(@canvas(), @chartOptions())

  chartOptions: ->
    unit = @canvas().dataset.unit
    {
      type: 'bar'
      data: {
        labels: @graphLabels()
        datasets: [{
          label: "Annual Dividends (#{unit})"
          data: @graphData()
          backgroundColor: "rgba(72,193,240,1)"
          borderColor: "rgba(37,164,215,1)"
          fill: false
        }]
      },
      options: {
        responsive: true
        maintainAspectRatio: false
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
              callback: (value, index, values) -> "#{value}#{unit}"
            }
          }]
        }
      }
    }

  graphLabels: ->
    vals = @textValues('#annual-dividends td:nth-child(1)')
    vals.slice(0, @graphData().length)

  graphData: ->
    vals = @textValues('#annual-dividends td:nth-child(2)')
    vals
      .map (text) -> parseFloat(text)
      .filter (num) -> !isNaN(num)

  textValues: (selector) ->
    Array.from(document.querySelectorAll(selector)).map (el) => el.innerText